import React from 'react'; 
import auth from './authService';
import { Navigate, Outlet } from "react-router-dom";
 

export default function PrivateRoute() {
  return   auth.isAuthenticated()    ? <Outlet /> : <Navigate to="/login" replace />;
}
